import { RiExternalLinkLine } from "react-icons/ri";
import { Link } from "react-router-dom";

import deviseSrc from "@/assets/svg/gouv-devise.svg";
import marianneBanner from "@/assets/svg/marianne-banner.svg";

const Footer = () => {
  return (
    <footer role="contentinfo" className="border-blue-france flex w-full flex-col justify-center border-t-2 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4">
        <div className="mt-10 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <Link className="hover:bg-gray-975 flex items-center gap-4 p-2" to="/">
            <div className="my-2 h-full w-24 shrink-0">
              <div className="flex flex-col items-start">
                <img src={marianneBanner} alt="" aria-hidden="true" className="mb-1 w-10" />
                <p className="text-xs leading-3 font-bold text-black uppercase">
                  République
                  <br />
                  française
                </p>
                <img src={deviseSrc} alt="" aria-hidden="true" className="mt-1 h-7" />
              </div>
            </div>
            <div>
              <p className="m-0 text-xl leading-7 font-bold text-black">API Engagement</p>
              <p className="text-sm">Plateforme de partage de missions de bénévolat et de volontariat</p>
            </div>
          </Link>
          <div className="max-w-2xl">
            <p className="text-grey-default mb-4 text-sm">
              L'API vous permet de faciliter l'engagement en simplifiant la démarche de recherche d'une mission de bénévolat ou de volontariat
            </p>

            <nav role="navigation" aria-label="Liens gouvernementaux">
              <ul role="list" className="text-grey-default flex flex-wrap items-center gap-x-6 gap-y-2 text-sm font-bold">
                <li>
                  <a href="https://www.legifrance.gouv.fr/" target="_blank" rel="noopener external" className="link-external">
                    legifrance.gouv.fr
                    <RiExternalLinkLine className="ml-1" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  <a href="https://www.gouvernement.fr/" target="_blank" rel="noopener external" className="link-external">
                    gouvernement.fr
                    <RiExternalLinkLine className="ml-1" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  <a href="https://www.service-public.fr/" target="_blank" rel="noopener external" className="link-external">
                    service-public.fr
                    <RiExternalLinkLine className="ml-1" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  <a href="https://www.data.gouv.fr/fr/" target="_blank" rel="noopener external" className="link-external">
                    data.gouv.fr
                    <RiExternalLinkLine className="ml-1" aria-hidden="true" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <nav role="navigation" aria-label="Liens de pied de page">
          <ul role="list" className="divide-text-mention border-grey-border text-text-mention mt-10 flex flex-wrap items-center divide-x border-t py-4 text-xs">
            <li>
              <Link to="/accessibilite" className="pr-3 hover:underline">
                Accessibilité : totalement conforme
              </Link>
            </li>
            <li>
              <Link to="/public-stats" className="px-3 hover:underline">
                Statistiques
              </Link>
            </li>
            <li>
              <a href="https://doc.api-engagement.beta.gouv.fr/" className="px-3 hover:underline">
                Documentation
              </a>
            </li>
            <li>
              <a href="https://api-engagement.beta.gouv.fr/mentions-legales/" className="px-3 hover:underline">
                Mentions légales
              </a>
            </li>
            <li>
              <a href="https://doc.api-engagement.beta.gouv.fr/get-started/rgpd" className="px-3 hover:underline">
                Données personnelles et cookies
              </a>
            </li>
            <li>
              <a href="https://api-engagement.beta.gouv.fr/politique-de-confidentialite/" className="px-3 hover:underline">
                Politique de confidentialité
              </a>
            </li>
            <li>
              <Link to="cgu" className="pl-3 hover:underline">
                CGU
              </Link>
            </li>
          </ul>
        </nav>
        <p className="text-text-mention flex flex-wrap items-center py-4 text-xs">
          Sauf mention explicite de propriété intellectuelle détenue par des tiers, les contenus de ce site sont proposés sous
          <a href="https://github.com/etalab/licence-ouverte/blob/master/LO.md" target="_blank" className="ml-1 flex items-center hover:underline">
            licence etalab-2.0
            <RiExternalLinkLine className="ml-1" aria-hidden="true" />
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
